/* eslint-disable @typescript-eslint/no-var-requires */
export const environment = {
  production: true,
  appVersion: require('../../package.json').version + '-dev',
  appName: require('../../package.json').name,
  appPrefix: 'vinfo',
  salesNavBackendUrl: 'https://essp-api-besalesnavigator-dev.acp-gruppe.com',
  portalBackendUrl: 'https://essp-api-besalesnavigator-dev.acp-gruppe.com',
  portalMetaBackendUrl: 'https://essp-api-beportalmetadata-dev.acp-gruppe.com',
  metaBackendUrl: 'https://essp-api-beportalmetadata-dev.acp-gruppe.com',
  portalHomeUrl: 'https://essp-dev.acp-gruppe.com',
  homeUrl: 'https://essp-success-navigator-dev.acp-gruppe.com',
  stage: 'dev',
  issuer: 'https://ciam-dev.acp-gruppe.com',
  tokenEndpoint: 'https://ciam-dev.acp-gruppe.com/token-srv/token',
  clientId: '5147878e-68fd-4ab7-b9ff-2adf5c046c5e',
  scope: 'openid profile roles groups acpprofile offline_access',
};
